import { useState, useEffect, useRef } from "react";
import axios from "axios";
import config from "../../../../config";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL   = config.MAP_MATCHING_API_URL;

const useEventsMonioringData = () => {
  const [events, setEvents]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  // refs to manage first‐load and interval
  const isFirstLoad = useRef(true);
  const intervalId  = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      // Only show loading spinner on very first call
      if (isFirstLoad.current) {
        setLoading(true);
        setError(null);
      }

      try {
        const bodyRaw = { filters: ["status-1"] };

        // console.log(`[${new Date().toLocaleTimeString()}] ⏳ Fetching events…`);
        const response = await axios.post(
          `${API_URL}/filtered-events`,
          bodyRaw,
          { headers: { "X-API-Key": API_TOKEN } }
        );

        // If you need to re‐compute status here, you can map in checkEventStatus

        setEvents(response.data);
        // console.log(
        //   `[${new Date().toLocaleTimeString()}] 📦 Received events:`,
        //   response.data
        // );
      } catch (err) {
        console.error(
          `[${new Date().toLocaleTimeString()}] ❌ Events fetch error:`,
          err
        );
        if (isFirstLoad.current) {
          setError("Error loading events data.");
        }
      } finally {
        // turn off loading only after first fetch (success or error)
        if (isFirstLoad.current) {
          setLoading(false);
          isFirstLoad.current = false;
        }
      }
    };

    // initial fetch + start polling every 60 seconds
    fetchData();
    intervalId.current = setInterval(fetchData, 60_000);

    return () => {
      clearInterval(intervalId.current);
    };
  }, []); // empty deps = run once on mount

  return { events, loading, error };
};

export default useEventsMonioringData;
